const getLocale = (locale) => {
  switch (true) {
    case locale.includes('es'):
      return './locales/es.json';
    default:
      return './locales/en.json';
  }
};

export default { getLocale };
